import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DotMenu, { Options } from '../../primitives/dotMenu/DotMenu';
import { MenuConstants } from '../../../constants/MenuConstants';
import ActionDropdown from '../../primitives/dropdowns/ActionDropdown';

interface SurveyMenuProps {
  className?: string;
  iconSize?: string;
  dropdownMenu?: boolean;
  onOptionClick?: Function;
  disabled?: boolean;
}

const SurveyMenu: React.FC<SurveyMenuProps> = ({
  iconSize = '',
  className = '',
  dropdownMenu = false,
  onOptionClick,
  disabled = false
}) => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<Options | null>();
  const { t } = useTranslation();

  useEffect(() => {
    if (selectedOption) {
      switch (selectedOption.key) {
        case MenuConstants.SURVEY_MENU_COPY:
          if (onOptionClick) {
            onOptionClick(MenuConstants.SURVEY_MENU_COPY);
          }
          break;
        case MenuConstants.SURVEY_EDIT:
          if (onOptionClick) {
            onOptionClick(MenuConstants.SURVEY_EDIT);
          }
          break;
      }
    }
  }, [selectedOption]);

  const dotMenuOptions: Array<any> = [
    {
      display: `${t('T_EDIT_SURVEY')}`,
      key: MenuConstants.SURVEY_EDIT
    },
    {
      display: `${t('T_SURVEY_COPY')}`,
      key: MenuConstants.SURVEY_MENU_COPY
    }
  ];

  return (
    <>
      {dropdownMenu ? (
        <ActionDropdown
          className={disabled ? 'disabled' : ''}
          options={dotMenuOptions}
          onSelectedOptionChange={(value: any) => {
            setSelectedOption(value);
          }}
          value={selectedOption}
          defaultLabel={t('T_MANAGE_SURVEY')}
        />
      ) : (
        <DotMenu
          options={dotMenuOptions}
          onSelectedOptionChange={(value) => {
            setSelectedOption(value);
          }}
          value={selectedOption}
        />
      )}
    </>
  );
};

export default SurveyMenu;
